import React, { useCallback } from 'react';
import { View, StyleSheet } from 'react-native';
import Banner from 'design-system/Banner';
import { Spacer, rem } from 'design-system';
import IconBlock from 'design-system/icons/IconBlock';
import SectionHeader from 'design-system/SectionHeader';
import useColors from 'hooks/useColors';
import TransactionLogo from 'features/transactions/components/TransactionLogo';
import { useMainStackNavigation } from 'utils/types/navigationV6';
const InactiveSubscriptionHeader = ({ name, hasData, subscription, }) => {
    const colors = useColors();
    const navigation = useMainStackNavigation();
    const changeToActive = useCallback(() => {
        navigation.navigateDeprecated('AdjustSubscription', {
            id: subscription.id,
            edit: true,
            activate: true,
        });
    }, [navigation, subscription.id]);
    return (<>
      <View style={styles.logoBox}>
        <TransactionLogo R44 transaction={subscription} name={name}/>
      </View>
      <Spacer h={30}/>
      <Banner noMarginBottom icon={<IconBlock color={colors.status.offline}/>} buttonTitle="Activate" onPress={changeToActive} title="This recurring payment is inactive" description="This can happen if there are no new payments. You are free to activate it, if you think this is a mistake"/>
      {hasData ? (<>
          <SectionHeader horizontalMargins style={styles.cardSectionHeader}>
            Past payments
          </SectionHeader>
          <Spacer.H16 />
        </>) : null}
    </>);
};
export default InactiveSubscriptionHeader;
const styles = StyleSheet.create({
    logoBox: {
        alignItems: 'center',
    },
    cardSectionHeader: {
        marginBottom: 0,
        marginTop: rem(24),
    },
});
